const basePath = '/mfe/common';

export const buildRoutePath = (urlPath: string): string =>
  `${basePath}${urlPath.startsWith('/') ? urlPath : `/${urlPath}`}`;
